/* Brændesgårdshaven – theme scripts (draft 1) */
(function () {
  'use strict';
  /* UI texts come from locales/*.json via window.BH_T (layout/theme.liquid); Danish fallbacks below */
  var T = Object.assign({
    low: 'Lavsæson', high: 'Højsæson', autumn: 'Efterår', closed: 'lukket', closed_until: 'lukket (åbner 5. juni)',
    open_today: 'Åbent i dag', water_park: 'Vandland', kids_water: 'Børnevandland åbent', closed_today: 'Lukket i dag',
    next_open: 'Næste åbningsdag', at: 'kl.', season_over: 'Sæsonen er slut', see_you: 'Vi ses i maj!',
    next_season: 'Sæson {year} offentliggøres i løbet af vinteren. Gavekort kan købes hele året.', to: 'til',
    close_menu: 'Luk menu', menu: 'Menu', need_photo: 'Tilføj et foto af kortholderen.', error: 'Noget gik galt – prøv igen.',
    take_photo: 'Tag foto nu', pick_photo: 'Vælg et foto', cam_label: 'Tag foto', cam_title: 'Kig ind i kameraet',
    cam_shot: 'Tag billedet', cancel: 'Annuller', cam_error: 'Vi kunne ikke åbne kameraet. Tillad kameraet i browseren – eller luk og vælg et foto i stedet.',
    retake: 'Tag et nyt foto', pick_other: 'Vælg et andet foto', not_image: 'Vælg en billedfil (fx JPG eller PNG).',
    too_big: 'Fotoet er for stort – vælg et mindre billede.', gift_to: 'Til {name}', gift_default: 'Til en, der fortjener en dag fuld af sjov'
  }, window.BH_T || {});
  var LOCALE = window.BH_LOCALE || document.documentElement.lang || 'da';

  /* ---------- Season calendar 2027 (from the park's "Åbningsdage 2027", Drive › Dokumenter) ----------
     Y = Lavsæson (gul, vandland åbent)  V = Lavsæson før vandland åbner 5. juni (gul)
     G = Højsæson (grøn)  T = Efterår, vandland lukket (blå)  R = Lukket */
  var CAL = {
    year: 2027,
    months: {
      5: 'RVRRVVVVVRRVRRVVVRVRRVVRRVRRVVR',
      6: 'RVRRYYRRYRRYYRRYRRYYRYYYYYYGGG',
      7: 'GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG',
      8: 'GGGGGGGGYYYYYYYRYYYRYYRRYRRYYRR',
      9: 'YRRYRRRTRRTRRRTRRTRRRTRRTRRRTR',
      10: 'RRRRRRRRRRRRRRRTRRRTTTTRRRRRRRR'
    },
    types: {
      Y: { name: T.low, park: '11.00–17.00', water: '12.00–16.00', rides: '12.00–16.00', color: '#FDD343' },
      V: { name: T.low, park: '11.00–17.00', water: T.closed_until, rides: '12.00–16.00', color: '#FDD343' },
      G: { name: T.high, park: '10.00–18.30', water: '11.00–17.00', rides: '11.00–17.00', color: '#3DBE6B' },
      T: { name: T.autumn, park: '11.00–17.00', water: T.closed, rides: '12.00–16.00', color: '#8FE3E8' },
      R: { name: T.closed.replace(/^./, function (c) { return c.toUpperCase(); }), park: T.closed, water: T.closed, rides: T.closed, color: '#F1EED7' }
    }
  };
  var MONTHS = ['januar','februar','marts','april','maj','juni','juli','august','september','oktober','november','december'];
  var DAYS = ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'];
  var DOW = ['M','T','O','T','F','L','S'];
  try {
    if (LOCALE !== 'da' && window.Intl) {
      var fm = new Intl.DateTimeFormat(LOCALE, { month: 'long' }), fd = new Intl.DateTimeFormat(LOCALE, { weekday: 'long' }), fn = new Intl.DateTimeFormat(LOCALE, { weekday: 'narrow' });
      MONTHS = MONTHS.map(function (x, i) { return fm.format(new Date(2027, i, 1)); });
      DAYS = DAYS.map(function (x, i) { return fd.format(new Date(2027, 0, 3 + i)); });   // 3 Jan 2027 is a Sunday
      DOW = DOW.map(function (x, i) { return fn.format(new Date(2027, 0, 4 + i)); });     // Monday first
    }
  } catch (e) {}
  function dayType(d) {
    if (d.getFullYear() !== CAL.year) return null;
    var m = CAL.months[d.getMonth() + 1];
    if (!m) return 'R';
    return m.charAt(d.getDate() - 1) || 'R';
  }
  function nextOpen(from) {
    var d = new Date(from);
    for (var i = 1; i < 400; i++) {
      d.setDate(d.getDate() + 1);
      var t = dayType(d);
      if (t && t !== 'R') return { date: new Date(d), type: t };
      if (d.getFullYear() > CAL.year) break;
    }
    return null;
  }
  function fmt(d) { return LOCALE === 'en' ? DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()] : DAYS[d.getDay()] + ' ' + d.getDate() + '. ' + MONTHS[d.getMonth()]; }
  window.BH = window.BH || {};
  window.BH.calendar = CAL; window.BH.dayType = dayType; window.BH.nextOpen = nextOpen; window.BH.fmtDate = fmt;
  window.BH.todayStatus = function () {
    var now = new Date(); var t = dayType(now);
    if (t && t !== 'R') {
      var info = CAL.types[t];
      return { open: true, label: T.open_today, hours: info.park, note: info.name + ' · ' + T.water_park + ' ' + info.water + (t === 'G' ? ' · ' + T.kids_water : ''), type: t };
    }
    var n = nextOpen(now);
    if (n) {
      var ni = CAL.types[n.type];
      return { open: false, label: T.closed_today, hours: T.next_open, note: fmt(n.date).replace(/^./, function (c) { return c.toUpperCase(); }) + ' ' + T.at + ' ' + ni.park + '.', next: n };
    }
    return { open: false, label: T.season_over, hours: T.see_you, note: T.next_season.replace('{year}', CAL.year + 1) };
  };

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Today card ---------- */
  $$('[data-bh-today]').forEach(function (el) {
    var s = window.BH.todayStatus();
    $('[data-bh-today-label]', el).textContent = s.label;
    $('[data-bh-today-hours]', el).innerHTML = s.open ? s.hours.replace('–', '<small> ' + T.to + ' </small>') : s.hours;
    $('[data-bh-today-note]', el).textContent = s.note;
  });

  /* ---------- Season calendar grid ---------- */
  $$('[data-bh-cal-year]').forEach(function (el) { el.textContent = CAL.year; });
  $$('[data-bh-calendar]').forEach(function (el) {
    var html = '';
    Object.keys(CAL.months).forEach(function (m) {
      var str = CAL.months[m]; var first = new Date(CAL.year, m - 1, 1);
      var offset = (first.getDay() + 6) % 7; // monday first
      html += '<div class="bh-cal__month"><h4>' + MONTHS[m - 1].replace(/^./, function (c) { return c.toUpperCase(); }) + '</h4><div class="bh-cal__grid">';
      DOW.forEach(function (d) { html += '<span class="bh-cal__dow">' + d + '</span>'; });
      for (var i = 0; i < offset; i++) html += '<span></span>';
      for (var d = 1; d <= str.length; d++) {
        var t = str.charAt(d - 1); var today = new Date(); var isToday = today.getFullYear() === CAL.year && today.getMonth() === m - 1 && today.getDate() === d;
        html += '<span class="bh-cal__d bh-cal__d--' + t + (isToday ? ' is-today' : '') + '" title="' + d + '. ' + MONTHS[m - 1] + ': ' + CAL.types[t].name + (t !== 'R' ? ' ' + CAL.types[t].park : '') + '">' + d + '</span>';
      }
      html += '</div></div>';
    });
    el.innerHTML = html;
  });

  /* ---------- Header: burger + dropdown ---------- */
  var burger = $('[data-bh-burger]'); var nav = $('[data-bh-nav]');
  if (burger && nav) {
    var header = burger.closest('.bh-header');
    var setMenu = function (open) {
      if (open && header) nav.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
      nav.classList.toggle('is-open', open);
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open);
      burger.setAttribute('aria-label', open ? T.close_menu : T.menu);
      document.documentElement.classList.toggle('bh-menu-open', open);
    };
    burger.addEventListener('click', function () { setMenu(!nav.classList.contains('is-open')); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('is-open')) { setMenu(false); burger.focus(); } });
    window.addEventListener('resize', function () { if (window.innerWidth > 980 && nav.classList.contains('is-open')) setMenu(false); });
    window.addEventListener('scroll', function () { if (nav.classList.contains('is-open') && header) nav.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px'; }, { passive: true });
  }
  $$('[data-bh-drop]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var li = btn.closest('.bh-nav__item');
      var open = li.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.bh-nav__item--drop')) $$('.bh-nav__item--drop.is-open').forEach(function (li) { if (window.innerWidth > 980) li.classList.remove('is-open'); });
  });

  /* ---------- Directory filters ---------- */
  $$('[data-bh-filter]').forEach(function (bar) {
    var grid = document.getElementById('dir-' + bar.getAttribute('data-bh-filter'));
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.bh-chip'); if (!b) return;
      $$('.bh-chip', bar).forEach(function (c) { c.classList.toggle('is-active', c === b); });
      var f = b.getAttribute('data-filter');
      $$('.bh-dir__item', grid).forEach(function (it) { it.hidden = !(f === '*' || it.getAttribute('data-cat') === f); });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bh-qty]'); if (!b) return;
    var input = b.parentNode.querySelector('input'); var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-bh-qty'), 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  $$('[data-bh-autosubmit]').forEach(function (i) {
    var t; i.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { i.form.submit(); }, 450); });
  });

  /* ---------- Variant price ---------- */
  $$('[data-bh-variant]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('form'); var price = form && $('[data-bh-price]', form);
      var opt = sel.options[sel.selectedIndex];
      if (price && opt) {
        var now = $('[data-bh-now]', price), cmp = $('[data-bh-compare]', price);
        if (now) now.textContent = opt.getAttribute('data-price'); else price.firstChild.nodeValue = opt.getAttribute('data-price') + ' ';
        if (cmp) { var c = opt.getAttribute('data-compare'); cmp.textContent = c; cmp.hidden = !c; }
      }
    });
    // Pre-select the price period that matches today (or the next open day)
    try {
      var s = window.BH.todayStatus(); var d = s.open ? new Date() : (s.next ? s.next.date : null);
      if (d) {
        var md = (d.getMonth() + 1) * 100 + d.getDate();
        var match = null;
        // 2027 periods; also matches variant names that still carry the 2026 dates
        if (md >= 501 && md <= 627) match = /(^|\D)(2|10)\. maj/i;
        else if (md >= 628 && md <= 808) match = /(28|29)\. juni/i;
        else if (md >= 809 && md <= 904) match = /(^|\D)(9|10)\. aug/i;
        else if (md >= 905 && md <= 1031) match = /(^|\D)(6|8)\. sep/i;
        var idx = md >= 501 && md <= 627 ? 0 : md >= 628 && md <= 808 ? 1 : md >= 809 && md <= 904 ? 2 : md >= 905 && md <= 1031 ? 3 : -1;
        var hit = -1;
        if (match) { for (var i = 0; i < sel.options.length; i++) { if (match.test(sel.options[i].text)) { hit = i; break; } } }
        // Translated variant names (English/German) don't contain the Danish month: fall back to position
        if (hit < 0 && idx >= 0 && sel.options.length === 4) hit = idx;
        if (hit >= 0) { sel.selectedIndex = hit; sel.dispatchEvent(new Event('change')); }
      }
    } catch (err) {}
  });

  /* ---------- AJAX add to cart ---------- */
  function updateCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-bh-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    });
  }
  $$('form[data-bh-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var photoInput = form.querySelector('[data-bh-photo-input]');
      if (photoInput && !form._bhPhoto && !photoInput.files.length) { var drop = form.querySelector('[data-bh-photo-drop]'); if (drop) drop.classList.add('is-invalid'); alertBox(form, T.need_photo); return; }
      var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
      var fd = new FormData(form);
      if (photoInput && form._bhPhoto) fd.set(photoInput.name, form._bhPhoto, 'kortholder.jpg');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (btn) btn.disabled = false;
          var ok = form.querySelector('[data-bh-added]');
          if (!res.ok) { alertBox(form, res.j.description || T.error); return; }
          if (ok) { ok.classList.add('is-visible'); setTimeout(function () { ok.classList.remove('is-visible'); }, 6000); }
          var err = form.querySelector('.bh-error'); if (err) err.textContent = '';
          if (form.hasAttribute('data-bh-photo-form')) resetPhotoForm(form);
          updateCount();
        })
        .catch(function () { if (btn) btn.disabled = false; form.submit(); });
    });
  });
  function alertBox(form, msg) {
    var el = form.querySelector('.bh-error'); if (!el) { el = document.createElement('div'); el.className = 'bh-error'; form.appendChild(el); }
    el.textContent = msg;
  }


  /* ---------- Season card: cardholder photo (v4-15) ---------- */
  // Phone photos are often 5–12 MB. Shrink to max 1200 px JPEG before upload so the
  // cart request stays small and fast; the original file is used if resizing fails.
  function shrinkPhoto(file, cb) {
    if (!window.createImageBitmap || !/^image\//.test(file.type)) return cb(null);
    createImageBitmap(file, { imageOrientation: 'from-image' }).then(function (bmp) {
      var max = 1200, sc = Math.min(1, max / Math.max(bmp.width, bmp.height));
      var c = document.createElement('canvas'); c.width = Math.round(bmp.width * sc); c.height = Math.round(bmp.height * sc);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      c.toBlob(function (b) { cb(b); }, 'image/jpeg', 0.85);
    }).catch(function () { cb(null); });
  }
  function resetPhotoForm(form) {
    form.reset(); form._bhPhoto = null;
    var prev = form.querySelector('[data-bh-photo-preview]'); if (prev) { if (prev.src) URL.revokeObjectURL(prev.src); prev.removeAttribute('src'); prev.hidden = true; }
    var empty = form.querySelector('[data-bh-photo-empty]'); if (empty) empty.hidden = false;
    var lbl = form.querySelector('[data-bh-photo-take-label]'); if (lbl) lbl.textContent = T.take_photo;
    var pick = form.querySelector('[data-bh-photo-pick]'); if (pick) pick.textContent = T.pick_photo;
  }
  var isTouch = window.matchMedia && matchMedia('(pointer: coarse)').matches;

  // Webcam window for computers (phones use the camera input with capture="user" instead).
  function webcam(onShot) {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return false;
    var box = document.createElement('div'); box.className = 'bh-cam'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', T.cam_label);
    box.innerHTML = '<div class="bh-cam__panel"><p class="bh-cam__title">' + T.cam_title + '</p><div class="bh-cam__view"><video playsinline muted autoplay></video><div class="bh-cam__guide" aria-hidden="true"></div></div>' +
      '<p class="bh-cam__msg" hidden></p><div class="bh-cam__btns"><button type="button" class="bh-btn bh-btn--green" data-shot>' + T.cam_shot + '</button><button type="button" class="bh-btn bh-btn--outline" data-close>' + T.cancel + '</button></div></div>';
    document.body.appendChild(box);
    var video = box.querySelector('video'), stream = null, msg = box.querySelector('.bh-cam__msg');
    function close() { if (stream) stream.getTracks().forEach(function (t) { t.stop(); }); box.remove(); document.removeEventListener('keydown', esc); }
    function esc(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', esc);
    box.querySelector('[data-close]').addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 960 } }, audio: false })
      .then(function (st) { stream = st; video.srcObject = st; })
      .catch(function () { msg.textContent = T.cam_error; msg.hidden = false; box.querySelector('[data-shot]').disabled = true; });
    box.querySelector('[data-shot]').addEventListener('click', function () {
      if (!video.videoWidth) return;
      var max = 1200, sc = Math.min(1, max / Math.max(video.videoWidth, video.videoHeight));
      var c = document.createElement('canvas'); c.width = Math.round(video.videoWidth * sc); c.height = Math.round(video.videoHeight * sc);
      var ctx = c.getContext('2d'); ctx.translate(c.width, 0); ctx.scale(-1, 1); // un-mirror to match what the person saw
      ctx.drawImage(video, 0, 0, c.width, c.height);
      c.toBlob(function (bl) { if (bl) onShot(bl); close(); }, 'image/jpeg', 0.88);
    });
    box.querySelector('[data-shot]').focus();
    return true;
  }

  $$('[data-bh-photo-form]').forEach(function (form) {
    var input = form.querySelector('[data-bh-photo-input]'); if (!input) return;
    var cam = form.querySelector('[data-bh-photo-camera]');
    var drop = form.querySelector('[data-bh-photo-drop]'), prev = form.querySelector('[data-bh-photo-preview]');
    var empty = form.querySelector('[data-bh-photo-empty]');
    var take = form.querySelector('[data-bh-photo-take]'), pick = form.querySelector('[data-bh-photo-pick]');
    var takeLbl = form.querySelector('[data-bh-photo-take-label]');
    input.required = false; // the script checks for a photo itself, from any of the three sources
    input.addEventListener('focus', function () { drop.classList.add('is-focus'); });
    input.addEventListener('blur', function () { drop.classList.remove('is-focus'); });

    function useBlob(blob) {
      form._bhPhoto = blob; drop.classList.remove('is-invalid');
      var err = form.querySelector('.bh-error'); if (err) err.textContent = '';
      if (prev.src) URL.revokeObjectURL(prev.src);
      prev.src = URL.createObjectURL(blob); prev.hidden = false; empty.hidden = true;
      if (takeLbl) takeLbl.textContent = T.retake;
      if (pick) pick.textContent = T.pick_other;
    }
    function useFile(f, from) {
      if (!f) return;
      if (!/^image\//.test(f.type)) { from.value = ''; alertBox(form, T.not_image); return; }
      var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
      shrinkPhoto(f, function (b) {
        if (btn) btn.disabled = false;
        if (!b && f.size > 15 * 1024 * 1024) { alertBox(form, T.too_big); from.value = ''; return; }
        useBlob(b || f);
      });
    }
    input.addEventListener('change', function () { useFile(input.files && input.files[0], input); });
    if (cam) cam.addEventListener('change', function () { useFile(cam.files && cam.files[0], cam); cam.value = ''; });
    if (pick) pick.addEventListener('click', function () { input.click(); });
    if (take) take.addEventListener('click', function () {
      if (isTouch && cam) { cam.click(); return; }
      if (!webcam(useBlob)) input.click();
    });
  });

  /* ---------- Gift card builder ---------- */
  var gf = $('[data-bh-giftform]');
  if (gf) {
    var idInput = $('[data-bh-gc-id]', gf); var amountEl = $('[data-bh-gc-amount]'); var toEl = $('[data-bh-gc-to]');
    $$('[data-bh-gc-pick]', gf).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-bh-gc-pick]', gf).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        idInput.value = b.getAttribute('data-bh-gc-pick');
        if (amountEl) amountEl.textContent = b.getAttribute('data-price');
      });
    });
    var nameInput = $('[data-bh-gc-name]', gf);
    if (nameInput && toEl) nameInput.addEventListener('input', function () { toEl.textContent = nameInput.value ? T.gift_to.replace('{name}', nameInput.value) : T.gift_default; });
    var rec = $('[data-bh-gc-recipient]', gf);
    $$('[data-bh-gc-mode]', gf).forEach(function (r) {
      r.addEventListener('change', function () {
        var self = r.value === 'self' && r.checked;
        rec.style.display = self ? 'none' : '';
        $$('input,textarea', rec).forEach(function (i) { i.disabled = self; });
      });
    });
    var date = $('#gc-date'); if (date) date.min = new Date().toISOString().slice(0, 10);
  }
})();
